import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-notice-modal',
  imports: [],
  templateUrl: './notice-modal.component.html',
  styleUrl: './notice-modal.component.css'
})
export class NoticeModalComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() imageSrc = '';
  @Input() imageAlt = 'Notice';
  @Input() maxWidth = '960px';

  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.isOpen = false;
    this.isOpenChange.emit(false);
    this.closed.emit();
  }
}
